import { createAction } from 'redux-actions';
export var toggle = createAction('REFUND/MODE/TOGGLE');
